import React from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import Icon from './Icon';
import { Color } from '../styles';
import { scale } from '../utils/scale.utils';

export const CheckboxInner = ({ selected, size = scale(24) }) => {
  return selected ? (
    <Icon style={[{ fontSize: size }, styles.check]} name="checkSolid" />
  ) : (
    <View
      style={[
        {
          borderRadius: size,
          width: size,
          height: size,
        },
        styles.rounded,
      ]}
    />
  );
};

export const Checkbox = ({ selected, size, ...rest }) => {
  return (
    <TouchableOpacity {...rest}>
      <CheckboxInner selected={selected} size={size} />
    </TouchableOpacity>
  );
};

//const checkIconSize = scale(24);
const styles = StyleSheet.create({
  rounded: {
    borderWidth: 0.5,
    borderColor: Color.gray,
  },
  check: {
    color: Color.primary,
  },
});
